export default __webpack_public_path__ + "static/media/cross-gray-icon.2ac0cf2a.svg";